import {
  ComunicatingReason,
  ConnectedComputersIcon,
  LastCommunicatedOn,
  TotalCommunicationIcon,
} from "icons";
import { Card } from "./card";
import { TicketCard } from "./ticketCard";
import { Activity } from "./activity";
import styles from "./styles.module.scss";
import { Tabs } from "./Tabs";
import { useEffect, useState } from "react";
import { tickets } from "./constants";
import { Divider } from "antd";
import {
  Allicon,
  CalibrationIcon,
  CapturingIcon,
  ForcePlateIcon,
  SubscriptionIcon,
} from "icon-components";

export const CommunicationReasons = ({
  heightOfTicketContainer,
  handleNext,
}) => {
  const [activeTab, setActiveTab] = useState("All");
  const [ticketsData, setTicketData] = useState(tickets);

  const cardsData = [
    {
      title: "Total Communication",
      value: 50,
      icon: TotalCommunicationIcon,
      color: "black",
    },
    {
      title: "Last Communicated On",
      value: "02.03.25",
      icon: LastCommunicatedOn,
      color: "black",
    },
    {
      title: "Last Communicated with",
      value: "Benet",
      icon: LastCommunicatedOn,
      color: "#46B764",
    },
    {
      title: "Communicated Reasons",
      value: "Capturing",
      icon: ComunicatingReason,
      color: "#006AB3",
    },
  ];
  const ticketTypes = [
    {
      title: "All",
      key: "All",
      Icon: Allicon,
      inactiveColor: "black",
      activeColor: "white",
    },
    {
      title: "Subscription",
      key: "Subscription",
      Icon: SubscriptionIcon,
      inactiveColor: "black",
      activeColor: "white",
    },
    {
      title: "Capturing",
      key: "Capturing",
      Icon: CapturingIcon,
      inactiveColor: "black",
      activeColor: "white",
    },
    {
      title: "Force Plates",
      key: "Force Plates",
      Icon: ForcePlateIcon,
      inactiveColor: "#19213D",
      activeColor: "white",
    },
    {
      title: "Calibration",
      key: "Calibration",
      Icon: CalibrationIcon,
      inactiveColor: "black",
      activeColor: "white",
    },
  ];

  function handleChangeIssuetype(activeTab) {
    if (activeTab === "All") return setTicketData(tickets);

    const filtered = tickets.filter((item) => item.issueType === activeTab);

    setTicketData(filtered);
  }

  useEffect(() => {
    handleChangeIssuetype(activeTab);
  }, [activeTab]);

  return (
    <div className={styles.reasonsContainer}>
      <h3>Communication Reasons</h3>
      <Divider />
      <div className={styles.cards}>
        {cardsData.map((item) => (
          <Card key={item.title} item={item} />
        ))}
      </div>
      <h3>Explore all Communications</h3>
      <div className={styles.desc}>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed,
        accusantium.
      </div>
      <div className={styles.tabs}>
        <Tabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsArr={ticketTypes}
        />
      </div>
      <div className={styles.ticketsContainer}>
        {ticketsData.map((item) => (
          <TicketCard key={item.id} item={item} handleNext={handleNext} />
        ))}
      </div>

      {/* <div
        className={styles.ticketSection}
        style={{ height: `${heightOfTicketContainer}` }}
      >
        <div className={styles.list}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
            <TicketCard key={item} />
          ))}
        </div>
        <div className={styles.messenger}>
          <Activity
          // singleTicketData={singleTicketData}
          // totalMessages={totalMessages}
          // setTotalMessages={setTotalMessages}
          // ticketId={ticketData?.ticket_id}
          />
        </div>
      </div> */}
    </div>
  );
};
